export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-6 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs md:text-sm font-medium mb-5">
              <i className="ri-flashlight-line text-sm"></i>
              <span>下拉式阅读 · 无弹窗 · 全屏观看</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              爱漫画网
              <span className="block text-primary-600">沉浸式漫画阅读平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-3">
              告别广告干扰，畅享纯净追漫体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              爱漫画网专注为漫画爱好者打造极致的在线阅读体验。我们提供下拉式漫画阅读、经典翻页漫画、清爽无弹窗模式以及沉浸式漫画全屏观看，
              让免费看漫画全集变成一种享受。无论你是追更热门连载，还是重温经典作品，这里都有属于你的阅读节奏。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">10,000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">漫画资源收录</div>
              </div>
              <div className="w-px h-10 bg-foreground-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">热门连载同步</div>
              </div>
              <div className="w-px h-10 bg-foreground-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">零广告</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">纯净阅读环境</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读热门漫画
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="inline-flex items-center gap-2 px-7 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold text-sm rounded-full hover:border-primary-400 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解阅读模式
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[380px] md:w-[380px] md:h-[480px] lg:w-[440px] lg:h-[540px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20reading%20scene:%20a%20person%20sitting%20comfortably%20on%20a%20cushion%20reading%20a%20colorful%20manga%20book%2C%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%20in%20soft%20warm%20orange%20and%20amber%20tones%2C%20gentle%20evening%20lighting%2C%20minimalist%20interior%20with%20warm%20wood%20textures%2C%20dreamy%20atmospheric%20illustration%20style%2C%20soft%20shadows%2C%20rich%20details%2C%20editorial%20quality&width=880&height=1080&seq=hero-main-visual&orientation=portrait"
                alt="爱漫画网沉浸式漫画阅读体验"
                title="爱漫画网沉浸式漫画阅读"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}